export {Login as Page};

import {useState, useContext} from 'preact/hooks';
import {signInWithEmailAndPassword} from 'firebase/auth';
import {auth} from '../../includes/firebase';
import {useLocation} from '../../hooks/useLocation.js';
import {Helmet} from "react-helmet-async";
import messages from "../../messages/messages.js";
import {NotificationContext} from '../../components/NotificationContext.jsx';
import {AccountDetail} from '../../components/AccountDetail.jsx';
import {GoogleAuthButton} from '../../components/GoogleAuthButton.jsx';
import {postLoginTarget} from '../../includes/redirect.js';
import {RingSpinner} from '../../components/Spinner.jsx';

function Login() {

    const location = useLocation();

    const {addNotification} = useContext(NotificationContext);

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const onLogin = (e) => {
        e.preventDefault();
        setLoading(true);
        signInWithEmailAndPassword(auth, email, password)
            .then(() => {
                location.route(postLoginTarget());
            })
            .catch((error) => {
                addNotification(error.message, 'error');
                setLoading(false);
            });
    }

    return (
        <section className="text-white">

            <Helmet>
                <title>{messages["SITE.NAME"]} | Login now!</title>
                <meta name="description" content="Want to login to your account?"/>
            </Helmet>

            <div className="flex flex-col md:flex-row justify-center gap-6">
                <div
                    className="w-full border border-border/60 bg-zinc-800 rounded-lg shadow-sm md:mt-0 sm:max-w-md xl:p-0">
                    <form action="#" className="p-6 space-y-4 md:space-y-6 sm:p-8">

                        <h1 className="text-xl font-bold leading-tight tracking-tight text-white md:text-2xl mb-2">
                            Sign in to your account
                        </h1>

                        <div className="text-xs text-gray-500">
                            Secure sign-in powered by <a href="https://firebase.google.com/products/auth"
                                                         target="_blank" className="text-gray-400 underline"
                                                         rel="noopener noreferrer">Google Firebase</a>
                        </div>

                        <div className="flex rounded-lg overflow-hidden border border-gray-400">
                            <a href="/login"
                               className="w-1/2 text-center text-white bg-gray-600/30 text-sm px-5 py-2.5 hover:bg-gray-600/50 border-r border-gray-400">Login</a>
                            <a href="/signup"
                               className="w-1/2 text-center text-white hover:bg-white hover:text-black text-sm px-5 py-2.5">Register</a>
                        </div>

                        <div>
                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-white">Your
                                email</label>
                            <input type="email" name="email" id="email"
                                   value={email}
                                   onChange={(e) => setEmail(e.target.value)}
                                   className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5"
                                   placeholder="name@company.com" required=""/>
                        </div>
                        <div>
                            <label htmlFor="password"
                                   className="block mb-2 text-sm font-medium text-white">Password</label>
                            <input type="password" name="password" id="password" placeholder="••••••••"
                                   value={password}
                                   onChange={(e) => setPassword(e.target.value)}
                                   className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5"
                                   required=""/>
                        </div>
                        <button type="submit" onClick={onLogin}
                                className="w-full mb-4 cursor-pointer text-white border border-gray-400 hover:bg-white hover:text-black font-medium rounded-lg text-sm px-5 py-2.5 text-center">Sign
                            in {loading && <RingSpinner/>}
                        </button>

                        <GoogleAuthButton
                            email={email}
                            disabled={loading}
                            label="Sign in with Google"
                        />

                        <p className="mb-0 text-xs text-gray-400">Did you <a href="/forgot-password" className="text-primary-500 hover:underline">forget password</a>?</p>
                    </form>
                </div>

                <AccountDetail />
            </div>
        </section>
    );
}
